"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtProvider = void 0;
var _providers = require("@ethersproject/providers");
var _RpcProvider = require("./RpcProvider");
class ExtProvider extends _providers.Web3Provider {
  async estimateGas(transaction) {
    return _RpcProvider.RpcProvider.estimateGas(this, await super.estimateGas(transaction), transaction);
  }
}
exports.ExtProvider = ExtProvider;
//# sourceMappingURL=ExtProvider.js.map